module.exports = __webpack_public_path__ + "img/cu08.bdb3326b.jpg";